import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import useApiLog from '@hooks/useApiLog'

const FailedApiLogActions = (props: { apiLog: { id: number } }) => {
  const { apiLog } = props

  const {
    callbacks: { editApiLog },
  } = useApiLog(apiLog)

  return (
    <Box justifyContent="center" alignItems="center">
      <Link
        greyLink
        onClick={() => editApiLog()}
        textProps={{ fontSize: 'medium', height: 'fit-content' }}
      >
        <FontAwesomeIcon icon={faPencil} />
      </Link>
    </Box>
  )
}

export default FailedApiLogActions
